import type { ApiRoutes } from '@tempo-io/integration-insights-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getIntegrationInsightsServiceApi = ({
  prefixUrl = '',
  client,
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<ApiRoutes>('/api/integration-insights/v1/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
